import { ListItem } from "../models/list-item";

export const getLanguageLevel = (
  id: number,
  levels: ListItem[]
): string => {
  return levels[id - 1].name;
};
